import React, { useEffect, useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { AiOutlineHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { FiShoppingCart, FiUser, FiUsers } from "react-icons/fi";
import { IoCallOutline } from "react-icons/io5";
import { RiCustomerService2Line } from "react-icons/ri";
import { Link, NavLink, useLocation, useParams, useSearchParams } from "react-router-dom";
import Logo from "../../../assets/images/appImages/yeksina_logo.png";
import Car from "../../../assets/images/icons/car.svg";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { getTotalAmount } from "../../../redux/slice/useCartSlice";
import { useGetCartByUserQuery, useGetListProductQuery, useGetProductListQuery } from "../../../utils/api/product/product.api";
import MobileCategoryModal from "../../user/ParcoursAchat/modal/MobileCategoryModal";
import CategoriesList from "./CategoriesList";
import ConnexionModal from "./modal/ConnexionModal";
import SearchForm from "./SearchForm";

const FrontHeader = () => {
  const dispatch = useAppDispatch();
  const { user, token } = useAppSelector((s) => s?.user);
  const { cartItems } = useAppSelector((state) => state.cart);
  // const { data:carts } = useGetCartByUserQuery(user?.slug);
  const [modalConnexion, setModalConnexion] = useState(false);
  let [searchParams] = useSearchParams();
  const [searchCategory, setSearchCategory] = useState<any>();
  const [searchSousCategory, setSearchSousCategory] = useState<any>();
  const [query, setQuery] = React.useState({
    category: searchParams?.get("category") || "",
    min: searchParams?.get("min") || "",
    max: searchParams?.get("max") || "",
    orderBy: searchParams?.get("orderBy") || "",
  });

  const [value, setValue] = React.useState<any>({
    min: searchParams?.get("min") || 0,
    max: searchParams?.get("max") || 9000000,
  });
  let { state } = useLocation();

  useEffect(() => {
    dispatch(getTotalAmount());
  }, [cartItems]);

  const [show, setShow] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 40) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <Navbar
        expand="lg"
        className="frontheader-component headering"
        id="navbar"
      >
        <div
          className={`second-header-custom no-view-mobile ${scrolled ? "scrolled" : ""
            }`}
        >
          <div className="content-left-second-header">
            <p className="text-second-header-custom">
              <FiUsers />
              <NavLink to={`/a-propos-de-nous`} className="btn no-link ">
                <span className="ps-2 text-second-header-custom">
                  Qui sommes-nous ?
                </span>
              </NavLink>
            </p>
          </div>
          <div className="content-left-second-header">
            <span>
              <IoCallOutline />
            </span>
            <Link
              to="tel:+221777165656"
              className="text-second-header-custom no-link"
            >
              +221 77 716 56 56
            </Link>
          </div>
        </div>
        <div
          className={`headering-second-level-header ${scrolled ? "scrolled" : ""
            }`}
        >
          <Navbar.Brand as={Link} to="/" className="no-view-mobile">
            <img src={Logo} alt="Tout" className="app-logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="no-view-mobile" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="navbar navbar-expand-lg navbar-light firstheader-costum nav-header-custom">
              <div className="w-100 header-navbar-contents-container">
                <div className="bloc-flex-info-user-header-content">
                  <div className="bloc-flex-info-user-header">
                    <div className="search-form-container no-view-mobile">
                      <SearchForm />
                    </div>
                    <div className="categorie-btn-container no-view-mobile">
                      <CategoriesList />
                    </div>
                  </div>
                </div>
                <div className="container-nav-content-nvlink p-2">
                  <Nav.Link as="div" className="p-0">
                    {!token ? (
                      <button
                        onClick={() => setModalConnexion(true)}
                        className="btn nav-link menu-link d-flex align-items-center"
                      >
                        <FiUser size={22} />
                        <span className="ps-2">Se Connecter</span>
                      </button>
                    ) : (
                      <NavLink
                        to={`/mon-compte/profil`}
                        className="btn nav-link menu-link"
                      >
                        <FiUser />
                        <span className="ps-2">Mon compte</span>
                      </NavLink>
                    )}

                    <ConnexionModal
                      modalConnexion={modalConnexion}
                      setModalConnexion={setModalConnexion}
                    />
                    <MobileCategoryModal
                      show={show}
                      setShow={setShow}
                      value={value}
                      setValue={setValue}
                      setSearchCategory={setSearchCategory}
                      setSearchSousCategory={setSearchSousCategory}
                      query={query}
                      setQuery={setQuery}
                      catgoryId={state?.catgoryId}
                    />
                  </Nav.Link>

                  <NavLink
                    to="/produits"
                    className="btn nav-link menu-link"
                  >
                    <img 
                      src="/icon_Nos_carrelages.png" 
                      alt="Notre carrelage" 
                    />
                    <span className="ps-2">Notre carrelage</span>
                  </NavLink>
                  <NavLink
                    to="/panier"
                    className="btn nav-link menu-link position-relative no-view-mobile"
                  >
                    <FiShoppingCart style={{ fontSize: 15 }} />
                    <span className="ps-2">Panier</span>
                    <span className="counter-shop-notif">
                      {cartItems?.length}
                    </span>
                  </NavLink>
                </div>
              </div>
              <div className="second-header-custom no-view-desktop">
                <div className="content-left-second-header">
                  <p className="text-second-header-custom">
                    <FiUsers />
                    <NavLink to={`/a-propos-de-nous`} className="btn no-link ">
                      <span className="ps-2 text-second-header-custom">
                        Qui sommes-nous ?
                      </span>
                    </NavLink>
                  </p>
                </div>
                <div className="content-left-second-header">
                  <span>
                    <IoCallOutline />
                  </span>
                  <Link
                    to="tel:+221777165656"
                    className="text-second-header-custom no-link"
                  >
                    +221 77 716 56 56
                  </Link>
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>
          <div className="container-menu-search-bloc-and-cart no-view-desktop position-relative">
            <div className="mobile-header-top-row">
              <Navbar.Brand as={Link} to="/" className="mobile-logo-brand">
                <img src={Logo} alt="Yeksina Home" className="app-logo" />
              </Navbar.Brand>
              <div className="search-form-container mobile-search-container">
                <SearchForm />
              </div>
              <div className="mobile-toggle-wrapper">
                <NavLink
                  to="/panier"
                  className="mobile-cart-in-toggle position-relative"
                >
                  <FiShoppingCart style={{ fontSize: 18, color: '#994B34' }} />
                  <span className="counter-shop-notif">{cartItems?.length}</span>
                </NavLink>
                <Navbar.Toggle 
                  aria-controls="basic-navbar-nav" 
                  className="mobile-toggle-btn"
                />
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </div>
  );
};

export default FrontHeader;
